import { ADD_CREDIT_CARD_FAILED, RESET_ERROR_STATE, ADD_PAYMENT_METHOD_SUCCESS } from './constants'
import * as constants from './constants'

const initialState = {
    addCreditCardFailedError: null,
    cardIsSuccessfullyAdded: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CREDIT_CARD_FAILED:
            return { ...state, addCreditCardFailedError: action.error }
        case RESET_ERROR_STATE:
            return { ...state, addCreditCardFailedError: null }
        case ADD_PAYMENT_METHOD_SUCCESS:
            return { ...state, cardIsSuccessfullyAdded: true }
        case constants.ADD_CREDIT_CARD_RESET:
            return {
                ...state,
                cardIsSuccessfullyAdded: null,
            }
        default:
            return state
    }
}

export default reducer
